<template >
  <Modal ref="modal">
    <div id="alertModal" class="modal-wrap active" style="z-index: 1001;">
      <div class="modal-inner">
        <div class="modal-content modal-xs" tabindex="-1">
          <div class="modal-header">
            <h2 class="modal-title">{{title}}</h2>
            <button type="button" class="btn-modal-close" @click="close">
              <img src="@/assets/img/ico/i-colse.svg" alt="닫기" />
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body-info sm" v-html="content"></div>
          </div>
          <div class="modal-footer">
            <div class="btn-group btn-space-xxs">
              <button
                type="button"
                class="btn btn-md btn-primary"
                @click="confirm"
              >{{confirmButtonText}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/base/Modal.vue";
export default {
  components: {
    Modal,
  },
  data: () => ({
    title: "확인",
    content: "확인해 주세요.",
    confirmButtonText: "확인",
    resolvePromise: undefined,
  }),
  methods: {
    show(content) {
      this.setContent(content);
      this.$refs.modal.open();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
      });
    },
    confirm() {
      this.$refs.modal.close();
      this.resolvePromise(true);
    },
    close() {
      this.$refs.modal.close();
      this.resolvePromise(false);
    },
    error(error) {
      console.error(error);
      if (error.response != undefined) {
        if (error.response.data != undefined) {
          if (error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event) => {
              this.setContent({
                title: "알림",
                content: JSON.parse(event.target.result).message,
              });
            };
            reader.readAsText(error.response.data);
          } else {
            this.setContent({
              title: "알림",
              content: error.response.data.message,
            });
          }
        }
      } else {
        this.setContent({
          title: "알림",
          content: "서버와 통신 중 오류가 발생하였습니다.",
        });
      }

      this.$refs.modal.open();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
      });
    },
    setContent(content) {
      if (content == undefined) {
        return;
      }

      this.title = content.title ? content.title : "확인";
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : "확인";
    },
  },
};
</script>